import PropTypes from 'prop-types'

import { estate } from '../../../../../constants'
import { DateUtils } from '../../../../../utils'
import { GreenDot, RedDot, YellowDot } from './StatusDot.styles'

const StatusDot = ({ isOnline, last_contact}) => {

    const temporalyOffline = DateUtils.now() - last_contact < estate.deviceActuallyOfflineMS
    
    if (isOnline) {
        return <GreenDot />
    }

    if (temporalyOffline) {
        return <YellowDot />
    }

    return <RedDot />
}

StatusDot.propTypes = {
    isOnline: PropTypes.bool,
    last_contact: PropTypes.number,
    isConnected: PropTypes.bool,
    isConnecting: PropTypes.bool,
}

StatusDot.defaultProps = {
    isOnline: false,
    last_contact: 0,
}

export default StatusDot
